import { styled, alpha } from "@mui/material";
import { InputBase, Button, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  appbar: {
    backgroundColor: theme.palette.background.main,
    color: theme.palette.text.main,
    height: theme.spacing(10),
    display: "flex",
    justifyContent: "center",
    zIndex: theme.zIndex.drawer + 1,
  },

  //   appbarIconContainer:{

  //     ":& button":{
  //       marginLeft:"5rem"
  //     }
  //   }
  // ,
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.background.main, 1),
    // "&:hover": {
    //   backgroundColor: alpha(theme.palette.common.white, 0.25),
    // },

    marginRight: theme.spacing(1),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.down("md")]: {
      marginLeft: theme.spacing(0),
    },

  },
}));

export const AppBarButton = styled(Button)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
  color: theme.palette.primary.main,
  transition: "0.5s",
  boxShadow: "none",
width:"140%",
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 1),
    color: theme.palette.text.tertiary,
  },

  //   backgroundColor: alpha(theme.palette.primary, 0.25),
  // },
}));

export const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",

  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",

    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

export const NavIconButtonWrapper = styled(Button)(({ theme }) => ({
  margin: theme.spacing(0, 1),
  height: theme.spacing(7),
  padding: 0,
  display: "flex",
  alignSelf: "center",

  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
  },
}));
